export default __webpack_public_path__ + "static/media/landing.86e94ae6.png";